import { GitCompare, Heart, ShoppingBag, User } from 'lucide-react';
import { memo } from 'react';

import { ICON_DEFAULT } from '@shared/constants/colors';
import { ROUTES } from '@shared/constants/routes';
import { useAppSelector } from '@shared/hooks/redux';
import { useClickMenuItem } from '@shared/hooks/useClickMenuItem';

import cls from './UserNavigation.module.scss';

export const UserNavigation = memo(() => {
  const cart = useAppSelector((state) => state.cart.productIds);
  const favorites = useAppSelector((state) => state.favorites.productIds);
  const comparison = useAppSelector((state) => state.comparison.productIds);

  const onClickHandler = useClickMenuItem();

  return (
    <nav
      data-testid="user-nav"
      className={cls.wrap}
    >
      <button
        aria-label={'Перейти в корзину'}
        className={cls.item}
        onClick={() => onClickHandler(ROUTES.CART)}
      >
        <div className={cls.iconWrapper}>
          <ShoppingBag color={ICON_DEFAULT} />
          {cart.length > 0 && (
            <div
              data-testid={'basket-counter'}
              className={cls.quantity}
            >
              {cart.length}
            </div>
          )}
        </div>
        Корзина
      </button>
      <button
        aria-label={'Перейти в личный кабинет'}
        className={cls.item}
        onClick={() => onClickHandler(ROUTES.PERSONAL_ACCOUNT)}
      >
        <User color={ICON_DEFAULT} />
        Профиль
      </button>
      <button
        aria-label={'Перейти в избранное'}
        className={cls.item}
        onClick={() => onClickHandler(ROUTES.FAVORITES)}
      >
        <div className={cls.iconWrapper}>
          <Heart color={ICON_DEFAULT} />
          {favorites.length > 0 && (
            <div
              data-testid={'favorites-counter'}
              className={cls.quantity}
            >
              {favorites.length}
            </div>
          )}
        </div>
        Избранное
      </button>
      <button
        aria-label={'Перейти на страницу сравнения товаров'}
        className={cls.item}
        onClick={() => onClickHandler(ROUTES.COMPARISON)}
      >
        <div className={cls.iconWrapper}>
          <GitCompare color={ICON_DEFAULT} />
          {comparison.length > 0 && <div className={cls.quantity}>{comparison.length}</div>}
        </div>
        Сравнение
      </button>
    </nav>
  );
});
